<template>
    <div>
        <h1>Statistics Important List</h1>
        <div>DATA</div>
    </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
// import $ from 'jquery';

import { SDLUtil, StringUtil } from '@/utils';

export default {
    name: 'admin-statistics-important-list',
    components: {
        // 'toast-grid': ToastGrid,
        // 'sdl-pagination': Pagination,
        // 'content-view': FindContentView,
    },
    data() {
        return {
            count: 1,
        };
    },
    created() {
        console.log("CREATED");
        this.loadList();
    },
    mounted() {
        console.log("MOUNTED");
    },
    destroyed() {
        console.log("DESTROYED");
    },
    methods: {
        loadList() {
            SDLUtil.showLoadingBar(true);

            return axios
                .get(`${SDLUtil.API_URL}/basis/admin/statisticsManager/statisticsManagerImportantList.skp`)
                .then(res => {
                    console.log("RESP", res);
                    SDLUtil.showLoadingBar(false);
                })
                .catch(err => {
                    // Vue.$log.error("ComMapMgmt",err);
                    SDLUtil.showLoadingBar(false);
                });
        },
    },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/skpComponents/view/admin/statisticsManager/ImportantList.vue